import { AsnMetaData, MetaDataEnum } from 'api/addons/models';

export function findAsnMetaData(
    metaDataArray?: Array<AsnMetaData>
): AsnMetaData | undefined {
    if (!metaDataArray || metaDataArray.length === 0) {
        return undefined;
    }
    return metaDataArray.find(
        (m): m is AsnMetaData => m.type === MetaDataEnum.Asn
    );
}
